/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmDuplicateCandidateFiltersResponse
 */
export interface MdmDuplicateCandidateFiltersResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MdmDuplicateCandidateFiltersResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmDuplicateCandidateFiltersResponse
     */
    sourceSystems?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmDuplicateCandidateFiltersResponse
     */
    guardVetoes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmDuplicateCandidateFiltersResponse
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the MdmDuplicateCandidateFiltersResponse interface.
 */
export function instanceOfMdmDuplicateCandidateFiltersResponse(value: object): value is MdmDuplicateCandidateFiltersResponse {
    return true;
}

export function MdmDuplicateCandidateFiltersResponseFromJSON(json: any): MdmDuplicateCandidateFiltersResponse {
    return MdmDuplicateCandidateFiltersResponseFromJSONTyped(json, false);
}

export function MdmDuplicateCandidateFiltersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmDuplicateCandidateFiltersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'sourceSystems': json['sourceSystems'] == null ? undefined : json['sourceSystems'],
        'guardVetoes': json['guardVetoes'] == null ? undefined : json['guardVetoes'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function MdmDuplicateCandidateFiltersResponseToJSON(json: any): MdmDuplicateCandidateFiltersResponse {
    return MdmDuplicateCandidateFiltersResponseToJSONTyped(json, false);
}

export function MdmDuplicateCandidateFiltersResponseToJSONTyped(value?: MdmDuplicateCandidateFiltersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'sourceSystems': value['sourceSystems'],
        'guardVetoes': value['guardVetoes'],
        'errorMessage': value['errorMessage'],
    };
}

